<template>
  <b-card>
    <div class="d-flex justify-content-between align-items-center mb-1">
      <h5 class="mb-0">
        Movimientos
      </h5>
      <div>
        <b-button
          size="sm"
          variant="outline-primary"
          @click="$emit('refresh')"
        >
          <b-spinner
            v-if="loading"
            small
            class="mr-1"
          /> Refrescar
        </b-button>
      </div>
    </div>

    <b-table
      :items="items"
      :fields="computedFields"
      :busy="loading"
      small
      responsive
      head-variant="light"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :empty-text="loading ? 'Cargando…' : 'Sin movimientos'"
      @sort-changed="onSortChanged"
    >
      <template #cell(created_at)="ctx">
        {{ formatDateTime(ctx.item.created_at) }}
      </template>

      <template #cell(reference)="ctx">
        <span v-if="ctx.item.reference_id">
          <router-link :to="`/checkout/${ctx.item.reference_id}`">
            Cotización #{{ ctx.item.reference_id }}
          </router-link>
        </span>
        <span
          v-else
          class="text-muted"
        >—</span>
      </template>

      <template #cell(tx_type)="ctx">
        <b-badge :variant="typeVariant(ctx.item)">
          {{ typeLabel(ctx.item) }}
        </b-badge>
      </template>

      <template #cell(amount)="ctx">
        <div :class="amountClass(ctx.item)">
          {{ money(displayAmount(ctx.item)) }}
        </div>
      </template>
    </b-table>

    <div class="d-flex justify-content-end">
      <b-pagination
        v-if="pagination.total_objects > pagination.per_page"
        :value="pagination.page"
        :per-page="pagination.per_page"
        :total-rows="pagination.total_objects"
        size="sm"
        class="mt-2"
        @change="$emit('change-page', $event)"
      />
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'WalletTransactionsTable',
  props: {
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    pagination: {
      type: Object,
      default: () => ({ page: 1, per_page: 50, total_objects: 0 }),
    },
    sortable: { type: Boolean, default: true },
  },
  data() {
    return {
      sortBy: 'created_at',
      sortDesc: true,
      baseFields: [
        {
          key: 'created_at', label: 'Fecha', sortable: true, thClass: 'align-middle',
        },
        { key: 'note', label: 'Descripción', thClass: 'align-middle' },
        { key: 'reference', label: 'Referencia', thClass: 'align-middle' },
        { key: 'tx_type', label: 'Tipo', thClass: 'align-middle' },
        {
          key: 'amount', label: 'Monto', thClass: 'text-right align-middle', tdClass: 'text-right',
        },
      ],
    }
  },
  computed: {
    computedFields() {
      return this.baseFields.map(f => (this.sortable ? { ...f, sortable: f.key !== 'reference' } : f))
    },
  },
  methods: {
    money(v) {
      const n = Number(v || 0)
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(n)
    },
    formatDateTime(v) {
      if (!v) return '—'
      const d = new Date(v)
      if (Number.isNaN(d.getTime())) return '—' // ✅ sin warning ESLint
      return new Intl.DateTimeFormat('es-MX', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      }).format(d)
    },
    adjustmentDelta(item) {
      const delta = Number(item && item.metadata && item.metadata.delta)
      if (!Number.isNaN(delta)) return delta
      return Number(item && item.amount) || 0
    },
    displayAmount(item) {
      if (!item) return 0
      if (item.tx_type === 'adjustment') return this.adjustmentDelta(item)
      return Number(item.amount || 0)
    },
    typeLabel(item) {
      const t = item && item.tx_type
      if (t === 'credit') return 'abono'
      if (t === 'debit') return 'egreso'
      if (t === 'adjustment') {
        const delta = this.adjustmentDelta(item)
        if (delta > 0) return 'ajuste +'
        if (delta < 0) return 'ajuste -'
        return 'ajuste'
      }
      return t || '—'
    },
    typeVariant(item) {
      const t = item && item.tx_type
      if (t === 'credit') return 'success'
      if (t === 'debit') return 'danger'
      if (t === 'adjustment') {
        const delta = this.adjustmentDelta(item)
        if (delta > 0) return 'success'
        if (delta < 0) return 'danger'
        return 'warning'
      }
      return 'secondary'
    },
    amountClass(item) {
      const t = item && item.tx_type
      if (t === 'credit') return 'text-success'
      if (t === 'debit') return 'text-danger'
      if (t === 'adjustment') {
        const delta = this.adjustmentDelta(item)
        if (delta > 0) return 'text-success'
        if (delta < 0) return 'text-danger'
        return 'text-warning'
      }
      return ''
    },
    onSortChanged(ctx) {
      this.$emit('sort-changed', { field: ctx.sortBy, direction: ctx.sortDesc ? 'desc' : 'asc' })
    },
  },
}
</script>
